import { createEntityFilterStore } from "./createEntityFilterStore";
import type { InvestmentFilters } from "@/domain/types";

const buildInitialFilters = (): InvestmentFilters => ({
	state: undefined,
	investor_uuid: undefined,
	beneficiary_uuid: undefined,
	investor_type: undefined,
	is_archived: false,
	amount_min: undefined,
	amount_max: undefined,
	fiscal_year: `${new Date().getFullYear()}`,
	search: "",
	sort: { key: undefined, direction: null },
});

export const useInvestmentFiltersStore =
	createEntityFilterStore<InvestmentFilters>(
		"InvestmentFiltersStore",
		buildInitialFilters,
	);
